<template>
  <div class="layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'layout'
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue